var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex w-100 h-100 justify-content-center align-items-center flex-column py-6",style:(_vm.getStyle())},[_c('b-spinner'),(_vm.text)?_c('div',{staticClass:"py-3"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }